
import React, { ChangeEvent, useEffect, useState } from 'react'
import Input from '../../components/UI/Input'
import SwitchInput from '../../components/UI/SwitchInput'
import { Divider, Input as AntdInput } from 'antd';
import {
  getConfig,
  updatePortalConfigurations,
  getConfigImages,
  saveWelcomeImages,
  saveConfigImages
} from '../../services/config';
import {sendSystemLog, useAuth} from "../../context/AuthProvider/useAuth";
import {serverUrl} from "../../services/api";
import { useLoading } from '../../context/LoadingProvider/useLoading'
import {IConfigMessageParams} from '../ConfigPages/types'
import Button from '../../components/UI/Button'
const { TextArea } = AntdInput;

export const switchOptions = {
  check: 'true',
  uncheck: 'false',
}

function Messaging() {
  const loading = useLoading()
  const {canEdit} = useAuth()
  const [settingsChanged, setSettingsChanged] = useState<boolean>(false)
  const [charityWelcomePreview, setCharityWelcomePreview] = useState<any|null>(null)
  const [distributorWelcomePreview, setDistributorWelcomePreview] = useState<any|null>(null)
  const [charityWelcomeImage, setCharityWelcomeImage] = useState<any|null>(null)
  const [distributorWelcomeImage, setDistributorWelcomeImage] = useState<any|null>(null)
  const [preview, setPreview] = useState<any|null>(null)
  const [image, setImage] = useState<any|null>(null)

  const log = {
    log_type: 'visited',
    log_object: 'messaging'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  useEffect(()=> {
    (async()=> {
      let res = await getConfigImages({
        name: config.IMAGE_OF_THE_DAY_FILE
      })
    })()
  },[])

  useEffect(() => {
    (async () => {
      loading.addLoading()
      const res = await getConfig()
      if(res.configs?.length > 0) {
        let requestConfigs = {
          ...config
        }
        res.configs.forEach((resConfig) => {
          let {value} = resConfig
          if(!value) return
          if(resConfig.key === 'MSG_HIGHPRIZE_JACKPOT_MINVALUE' || resConfig.key === 'MSG_HIGHPRIZE_BIGWIN_MINVALUE') value = `${parseInt(value)}`
          requestConfigs = {
            ...requestConfigs,
            [resConfig.key as keyof typeof config]: value
          }
        })
        setConfig(requestConfigs)
      }
      loading.removeLoading()
    })()
  }, [])

  const mountImageUrl = (imageName: string) => {
      return serverUrl + "/images/" + imageName
  }

  const changeConfigSettings = (e: string, field: string) => {
    setSettingsChanged(true)
    setConfig({
      ...config,
      [field] : e
    })
  }

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>, type: 'charity'|'distributor'| '' ) => {
      if (e.target.files) {
        const objectUrl = URL.createObjectURL(e.target.files[0])
        if(type === 'charity') {
          setCharityWelcomePreview(objectUrl)
          setCharityWelcomeImage(e.target.files[0])
          changeConfigSettings(e.target.files[0].name, 'PORTAL_WELCOME_SCREEN_CHARITY_MEDIA_FILE_NAME')
        }
        if(type === 'distributor') {
          setDistributorWelcomePreview(objectUrl)
          setDistributorWelcomeImage(e.target.files[0])
          changeConfigSettings(e.target.files[0].name, 'PORTAL_WELCOME_SCREEN_DISTRIBUTOR_MEDIA_FILE_NAME')
        }
        if(type === '') {
          setPreview(objectUrl)
          setImage(e.target.files[0]);
          changeConfigSettings(e.target.files[0].name, 'IMAGE_OF_THE_DAY_FILE')
        }
      }
  }

  const uploadImage = async (type: 'charity'|'distributor' ) => {
      if(type === 'charity') {
        let formData = new FormData()
        formData.append('files', charityWelcomeImage)
        await saveWelcomeImages(charityWelcomeImage, {
          key: 'PORTAL_WELCOME_SCREEN_CHARITY_MEDIA_FILE_NAME',
          url: config.PORTAL_WELCOME_SCREEN_CHARITY_URL,
        })
      }
      if(type === 'distributor') {
        let formData = new FormData()
        formData.append('files', distributorWelcomeImage)
        await saveWelcomeImages(distributorWelcomeImage, {
          key: 'PORTAL_WELCOME_SCREEN_DISTRIBUTOR_MEDIA_FILE_NAME',
          url: config.PORTAL_WELCOME_SCREEN_DISTRIBUTOR_URL,
        })
      }
  }

  const [config, setConfig] = useState<IConfigMessageParams>({
    PORTAL_WELCOME_SCREEN_CHARITY_MEDIA_FILE_NAME: "",
    PORTAL_WELCOME_SCREEN_DISTRIBUTOR_MEDIA_FILE_NAME: "",
    MSG_GAME_SYSTEM_ENABLE: "",
    MSG_GAME_SYSTEM: "",
    MSG_CASHIER_SYSTEM_ENABLE: "",
    MSG_CASHIER_SYSTEM: "",
    MSG_TERMS_OF_SERVICE_ENABLE: "",
    MSG_TERMS_OF_SERVICE: "",
    MSG_PRIVACY_POLICY_ENABLE: "",
    MSG_PRIVACY_POLICY: "",
    MSG_ENABLE_NEW_CASHIER_SESSION: "",
    MSG_TITLE_NEW_CASHIER_SESSION: "",
    MSG_BODY_NEW_CASHIER_SESSION: "",
    MSG_ENABLE_NEW_GAME_SESSION: "",
    MSG_TITLE_NEW_GAME_SESSION: "",
    MSG_BODY_NEW_GAME_SESSION: "",
    PORTAL_WELCOME_SCREEN_CHARITY_MEDIA_ENABLED: "",
    PORTAL_WELCOME_SCREEN_CHARITY_URL: "",
    PORTAL_WELCOME_SCREEN_DISTRIBUTOR_MEDIA_ENABLED: "",
    PORTAL_WELCOME_SCREEN_DISTRIBUTOR_URL: "",
    IMAGE_OF_THE_DAY_FILE: "",
    ENABLE_IMAGE_OF_THE_DAY: "",
    IMAGE_OF_THE_DAY_SHOW_TIME: "",
  })

  const updateConfigs = async () => {
      let formData = new FormData()
      const configParsed = {
        ...config,
      }

      const configsAsArray = Object.keys(configParsed).map((key) => {
        return {key, value: configParsed[key as keyof typeof configParsed]}
      })

      const filtered = configsAsArray.filter((config: any) => !config.key.includes('PT_GAME_TAGS') && !config.key.includes('LOBBY_TABS'))


      let res : boolean = true
      if(image) {
        res = await saveConfigImages(image)
      }
      if(res) {
        await updatePortalConfigurations(filtered)
      }
      setSettingsChanged(false)
  }

    return (
    <div className="config">
      <div className="config-messaging__row">
        <SwitchInput
          label="System Message - Game Device Message"
          value={config.MSG_GAME_SYSTEM_ENABLE}
          options={switchOptions}
          onChange={(e) => changeConfigSettings(e, 'MSG_GAME_SYSTEM_ENABLE')}
          disabled={!canEdit}
        />
        {config.MSG_GAME_SYSTEM_ENABLE === switchOptions.check && (
          <Input
            label=''
            value={config.MSG_GAME_SYSTEM}
           onChange={(e: any) => changeConfigSettings(e.target.value, 'MSG_GAME_SYSTEM')}
            disabled={!canEdit}
          />
        )}
      </div>
      <Divider />
      <div className="config-messaging__row">
        <SwitchInput
          label="System Message - Cashier Device Message"
          value={config.MSG_CASHIER_SYSTEM_ENABLE}
          options={switchOptions}
          onChange={(e) => changeConfigSettings(e, 'MSG_CASHIER_SYSTEM_ENABLE')}
          disabled={!canEdit}
        />
        {config.MSG_CASHIER_SYSTEM_ENABLE === switchOptions.check && (
          <Input
            label=''
            value={config.MSG_CASHIER_SYSTEM}
            onChange={(e: any) => changeConfigSettings(e.target.value, 'MSG_CASHIER_SYSTEM')}
            disabled={!canEdit}
          />
        )}
      </div>
      <Divider />
      <div className="config-messaging__row">
        <SwitchInput
          label="System Message - Terms of Service Message"
          value={config.MSG_TERMS_OF_SERVICE_ENABLE}
          options={switchOptions}
          onChange={(e) => changeConfigSettings(e, 'MSG_TERMS_OF_SERVICE_ENABLE')}
          disabled={!canEdit}
        />
        {config.MSG_TERMS_OF_SERVICE_ENABLE === switchOptions.check && (
          <TextArea
            rows={4}
            value={config.MSG_TERMS_OF_SERVICE}
            onChange={(e: any) => changeConfigSettings(e.target.value, 'MSG_TERMS_OF_SERVICE')}
            disabled={!canEdit}
          />
        )}
      </div>
      <Divider />
      <div className="config-messaging__row">
        <SwitchInput
          label="System Message - Privacy Policy Message"
          value={config.MSG_PRIVACY_POLICY_ENABLE}
          options={switchOptions}
          onChange={(e) => changeConfigSettings(e, 'MSG_PRIVACY_POLICY_ENABLE')}
          disabled={!canEdit}
        />
        {config.MSG_PRIVACY_POLICY_ENABLE === switchOptions.check && (
          <TextArea
            rows={4}
            value={config.MSG_PRIVACY_POLICY}
            onChange={(e: any) => changeConfigSettings(e.target.value, 'MSG_PRIVACY_POLICY')}
            disabled={!canEdit}
          />
        )}
      </div>
      <Divider />
      <div className="config-messaging__row">
        <SwitchInput
          label="Message of the Day - Cashier Device"
          value={config.MSG_ENABLE_NEW_CASHIER_SESSION}
          options={switchOptions}
          onChange={(e) => changeConfigSettings(e, 'MSG_ENABLE_NEW_CASHIER_SESSION')}
          disabled={!canEdit}
        />
        {config.MSG_ENABLE_NEW_CASHIER_SESSION === switchOptions.check && (
          <>
            <Input
              label='Title'
              value={config.MSG_TITLE_NEW_CASHIER_SESSION}
              onChange={(e: any) => changeConfigSettings(e.target.value, 'MSG_TITLE_NEW_CASHIER_SESSION')}
              disabled={!canEdit}
            />
            <Input
              style={{ width: '100%' }}
              label='Message Body'
              value={config.MSG_BODY_NEW_CASHIER_SESSION}
              onChange={(e: any) => changeConfigSettings(e.target.value, 'MSG_BODY_NEW_CASHIER_SESSION')}
              disabled={!canEdit}
            />
          </>
        )}
      </div>
      <Divider />
      <div className="config-messaging__row">
        <SwitchInput
          label="Message of the Day - Game Device Title"
          value={config.MSG_ENABLE_NEW_GAME_SESSION}
          options={switchOptions}
          onChange={(e) => changeConfigSettings(e, 'MSG_ENABLE_NEW_GAME_SESSION')}
          disabled={!canEdit}
        />
        {config.MSG_ENABLE_NEW_GAME_SESSION === switchOptions.check && (
          <>
            <Input
              label='Title'
              value={config.MSG_TITLE_NEW_GAME_SESSION}
              onChange={(e: any) => changeConfigSettings(e.target.value, 'MSG_TITLE_NEW_GAME_SESSION')}
              disabled={!canEdit}
            />
            <Input
              style={{ width: '100%' }}
              label='Message Body'
              value={config.MSG_BODY_NEW_GAME_SESSION}
              onChange={(e: any) => changeConfigSettings(e.target.value, 'MSG_BODY_NEW_GAME_SESSION')}
              disabled={!canEdit}
            />
          </>
        )}
      </div>
      <Divider />
      <div className="config-messaging__row">
        <SwitchInput
            label="Image of the Day - Game Device"
            value={config.ENABLE_IMAGE_OF_THE_DAY}
            options={switchOptions}
            onChange={(e) => changeConfigSettings(e, 'ENABLE_IMAGE_OF_THE_DAY')}
            disabled={!canEdit}
        />
        {config.ENABLE_IMAGE_OF_THE_DAY === switchOptions.check && (
            <>
              {preview && (
                  <div style={{width: '100px', height: '100px', marginBottom: '40px'}}>
                    <img  src={preview} style={{width: '100%'}}/>
                  </div>
              )}
              {!preview && (
                  <div style={{width: '100px', height: '100px', marginBottom: '40px'}}>
                    <img  src={serverUrl + '/images/' + config.IMAGE_OF_THE_DAY_FILE}
                          style={{width: '100%'}}/>
                  </div>
              )}
              <div style={{marginBottom: 10}}>
                <p>{config.IMAGE_OF_THE_DAY_FILE}</p>
                <input accept="image/png, image/gif, image/jpeg" name="file" type="file" onChange={(e) => handleFileChange(e, '')}  disabled={!canEdit}/>
                <p>Max File Size 1024x768</p>
              </div>
              <Input
                  label='Show Time (seconds)'
                  value={config.IMAGE_OF_THE_DAY_SHOW_TIME}
                  onChange={(e: any) => changeConfigSettings(e.target.value, 'IMAGE_OF_THE_DAY_SHOW_TIME')}
                  type="number"
                  disabled={!canEdit}
              />
            </>
        )}
      </div>
      <Divider />
      <div className="config-messaging__row">
        <SwitchInput
          label="Charity Welcome Media"
          value={config.PORTAL_WELCOME_SCREEN_CHARITY_MEDIA_ENABLED}
          options={switchOptions}
          onChange={(e) => changeConfigSettings(e, 'PORTAL_WELCOME_SCREEN_CHARITY_MEDIA_ENABLED')}
          disabled={!canEdit}
        />
        {config.PORTAL_WELCOME_SCREEN_CHARITY_MEDIA_ENABLED === switchOptions.check && (
          <>
            {config.PORTAL_WELCOME_SCREEN_CHARITY_MEDIA_FILE_NAME && (
              <div style={{width: '100px', height: '100px', marginBottom: '40px'}}>
                <img src={charityWelcomePreview || mountImageUrl(config.PORTAL_WELCOME_SCREEN_CHARITY_MEDIA_FILE_NAME)} style={{width: '100%'}}/>
                <p>{charityWelcomeImage?.name || ''}</p>
              </div>
            )}
            <div style={{marginBottom: 10}}>
              <input accept="image/png, image/gif, image/jpeg" name="file" type="file" onChange={(e) => handleFileChange(e, 'charity')} disabled={!canEdit} />
            </div>
            <div className="input-component__label">Charity Welcome URL</div>
            <Input
              label='(optional, when the portal user clicks on the image it will be redirected to this URL)'
              value={config.PORTAL_WELCOME_SCREEN_CHARITY_URL}
              onChange={(e: any) => changeConfigSettings(e.target.value, 'PORTAL_WELCOME_SCREEN_CHARITY_URL')}
              disabled={!canEdit}
            />
            <Button disabled={!canEdit || !charityWelcomePreview} type="primary" onClick={() => uploadImage('charity')}><p>Upload</p></Button>
          </>
        )}
      </div>
      <Divider />
      <div className="config-messaging__row">
        <SwitchInput
          label="Distributor Welcome Media"
          value={config.PORTAL_WELCOME_SCREEN_DISTRIBUTOR_MEDIA_ENABLED}
          options={switchOptions}
          onChange={(e) => changeConfigSettings(e, 'PORTAL_WELCOME_SCREEN_DISTRIBUTOR_MEDIA_ENABLED')}
          disabled={!canEdit}
        />
        {config.PORTAL_WELCOME_SCREEN_DISTRIBUTOR_MEDIA_ENABLED === switchOptions.check && (
          <>
            {config.PORTAL_WELCOME_SCREEN_DISTRIBUTOR_MEDIA_FILE_NAME && (
              <div style={{width: '100px', height: '100px', marginBottom: '40px'}}>
                <img  src={distributorWelcomePreview || mountImageUrl(config.PORTAL_WELCOME_SCREEN_DISTRIBUTOR_MEDIA_FILE_NAME)} style={{width: '100%'}}/>
                <p>{distributorWelcomeImage?.name || ''}</p>
              </div>
            )}
            <div style={{marginBottom: 10}}>
              <input accept="image/png, image/gif, image/jpeg" name="file" type="file" onChange={(e) => handleFileChange(e, 'distributor')} disabled={!canEdit} />
            </div>
            <div className="input-component__label">Distributor Welcome URL</div>
            <Input
              label='(optional, when the portal user clicks on the image it will be redirected to this URL)'
              value={config.PORTAL_WELCOME_SCREEN_DISTRIBUTOR_URL}
              onChange={(e: any) => changeConfigSettings(e.target.value, 'PORTAL_WELCOME_SCREEN_DISTRIBUTOR_URL')}
              disabled={!canEdit}
            />
            <Button disabled={!canEdit || !distributorWelcomePreview} type="primary" onClick={() => uploadImage('distributor')}><p>Upload</p></Button>
          </>
        )}
      </div>
      <Divider />
      <div className="config__save">
          <Button disabled={!canEdit || !settingsChanged}
                  type="primary"
                  onClick={updateConfigs}>
            <p>Save</p>
          </Button>
        </div>
    </div>
  )
}

export default Messaging
